// Deprecated. Import from 'metadata.js' directly instead.
export { getCountryCallingCode as default } from './metadata.js';
//# sourceMappingURL=getCountryCallingCode.js.map


//////////////////
// WEBPACK FOOTER
// ../libphonenumber-js/es6/getCountryCallingCode.js
// module id = 173
// module chunks = 0 1